function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .svg-upload-progress-icon{fill:none;stroke:#ebeef0;stroke-width:3px;}\n            .svg-upload-progress-icon-background{fill:#00b2ae;}\n            .svg-upload-progress-icon-white{fill:#fff;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-350.5 -186.5)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "svg-upload-progress-icon",
  cx: 48,
  cy: 48,
  r: 48,
  transform: "translate(352 188)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "svg-upload-progress-icon-background",
  cx: 40,
  cy: 40,
  r: 40,
  transform: "translate(360 196)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(380 216)"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-upload-progress-icon-white",
  d: "M32.3,10.071a12.515,12.515,0,0,0-24.546-.008A8.76,8.76,0,0,0,8.767,27.527h6.257a1.252,1.252,0,0,0,0-2.5H8.767a6.258,6.258,0,1,1,.074-12.515A1.251,1.251,0,0,0,10.085,11.4a10.012,10.012,0,0,1,19.891,0,1.326,1.326,0,0,0,1.318,1.114,6.257,6.257,0,1,1,0,12.515H25.037a1.252,1.252,0,1,0,0,2.5h6.258A8.76,8.76,0,0,0,32.3,10.071Z",
  transform: "translate(0 1.875)"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-upload-progress-icon-white",
  d: "M11,7.446a1.251,1.251,0,0,0,1.8-1.739l-.031-.031L7.462.368a1.252,1.252,0,0,0-1.77,0l0,0L.382,5.677a1.251,1.251,0,1,0,1.739,1.8l.031-.031L5.324,4.272V20.024a1.251,1.251,0,1,0,2.5,0V4.272Z",
  transform: "translate(13.455 16.887)"
})));

function SvgUploadProgressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProgressIcon);
export default __webpack_public_path__ + "static/media/upload-progress-icon.33696e38.svg";
export { ForwardRef as ReactComponent };